import React from 'react';
import './Hero.scss';
import { EMAIL } from '../../constants/data';

const Hero = () => {
  const mailToUrl = `mailto:${EMAIL}`;

  return (
    <section id="hero" className="hero">
      <div className="hero-content">
        <h1>Hey, I’m Yevhenii.</h1>
        <p>
          I like making cool stuff for the web. If it runs smooth and looks
          good, I’m happy.
        </p>
        <div className="hero-buttons">
          <a href={mailToUrl} className="cta-button">
            Say Hello
          </a>
          <a
            href="/resume.pdf"
            className="cta-button secondary"
            download="Yevhenii Volotskov CV.pdf"
          >
            PDF of Me
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
